import { render, staticRenderFns } from "./GalleryType6.vue?vue&type=template&id=41bc5732"
import script from "./GalleryType6.vue?vue&type=script&lang=js"
export * from "./GalleryType6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41bc5732')) {
      api.createRecord('41bc5732', component.options)
    } else {
      api.reload('41bc5732', component.options)
    }
    module.hot.accept("./GalleryType6.vue?vue&type=template&id=41bc5732", function () {
      api.rerender('41bc5732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryType6.vue"
export default component.exports